import type { Locale } from '@/lib/serviceCatalog';

export type ProcessStep = {
  name: string;
  text: string;
};

const PROCESS_STEPS: Record<Locale, ProcessStep[]> = {
  tr: [
    {
      name: 'Keşif & Strateji',
      text: 'Projenizin hedeflerini, kullanıcı ihtiyaçlarını ve teknik gereksinimleri derinlemesine analiz ediyoruz. Kapsamlı keşif dokümanı ile paydaşlarla ortak vizyon oluşturuyoruz.',
    },
    {
      name: 'Tasarım & Prototip',
      text: 'Wireframe’lerden yüksek kaliteli prototiplere kadar kullanıcı deneyimini mükemmelleştiriyoruz. Tasarım spesifikasyonları ile her karar şeffaf kalır.',
    },
    {
      name: 'Geliştirme & Test',
      text: 'Güncel teknolojilerle geliştiriyor, kapsamlı testlerle kaliteyi garanti altına alıyoruz. Teknik dokümantasyon ile süreç boyunca görünürlük sağlıyoruz.',
    },
    {
      name: 'Lansman & Büyüme',
      text: 'Ürünü pazara sunuyor, performans takibi ve sürekli optimizasyonla büyümeyi destekliyoruz. Lansman sonrası analiz ve büyüme planı ile devam ediyoruz.',
    },
  ],
  en: [
    {
      name: 'Discovery & Strategy',
      text: 'We analyze goals, user needs, and technical requirements in depth and align stakeholders with a shared vision through a discovery document.',
    },
    {
      name: 'Design & Prototype',
      text: 'From wireframes to high-fidelity prototypes, we refine UX end to end with transparent design specifications.',
    },
    {
      name: 'Development & Testing',
      text: 'We build with modern technologies, validate quality through comprehensive testing, and document the process for full visibility.',
    },
    {
      name: 'Launch & Growth',
      text: 'We launch your product and support growth with performance monitoring, optimization, and post-launch analysis.',
    },
  ],
};

export function getHomeProcessSteps(lang: Locale): ProcessStep[] {
  return PROCESS_STEPS[lang];
}

export function getHomeHowToMeta(lang: Locale) {
  return lang === 'tr'
    ? {
        name: 'Figtures ile ürün geliştirme süreci',
        description:
          'Keşif ve stratejiden lansmana kadar Figtures product studio teslimat akışı: AI, SaaS ve özel yazılım projeleri için.',
      }
    : {
        name: 'How to build a product with Figtures',
        description:
          'Figtures product studio delivery flow from discovery through launch, for AI, SaaS, and custom software projects.',
      };
}
